@if (selectionMode() === 'range') {
  <mat-calendar
    #picker
    [selected]="effectiveSelectedDateRange()"
    (selectedChange)="rangeChanged($event)"
    [headerComponent]="calendarHeader"
    [startAt]="initialDate()"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
  />
} @else {
  <mat-calendar
    #picker
    [selected]="effectiveSelectedDate()"
    (selectedChange)="dateChanged($event)"
    [headerComponent]="calendarHeader"
    [startAt]="initialDate()"
    [minDate]="minDate()"
    [maxDate]="maxDate()"
  />
}
